module.exports = window.fetch || (window.fetch = require('unfetch').default || require('unfetch'));



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-unfetch/browser.js
// module id = 1323
// module chunks = 0